import React from 'react'
import cx from 'classnames'
import styles from './FulfillmentList.module.css'
import { useTranslation } from 'react-i18next'
import Loader from '../../../components/Loader'
import { Fulfiller } from '../../../types/Fulfiller'
import { closeModal, openModal } from '../../../services/ModalService'
import { useFetchData } from '../../../hooks/useFetchData'
import { ApiRoutes } from '../../../services/ApiService'
import Button from '../../../components/Button'
import CreateFulfillerModal from './CreateFulfillmentModal'
import EditFulfillerModal from './EditFulfillerModal/EditFulfillerModal'

const FulfillmentList: React.FC = () => {
    const { t } = useTranslation(['settings'])

    const {
        data: fulfiller,
        fetch,
        isLoading,
    } = useFetchData<Fulfiller>(ApiRoutes.FULFILLER)

    React.useEffect(() => {
        fetch()
    }, [fetch])

    const openCreateModal = () => {
        const content: JSX.Element = (
            <div style={{ minWidth: '350px' }}>
                <CreateFulfillerModal
                    onSubmit={() => {
                        fetch()
                        closeModal()
                    }}
                />
            </div>
        )
        openModal({
            heading: t('fulfillment.create_modal.heading'),
            content: content,
        })
    }

    const openEditModal = (f: Fulfiller) => {
        const content: JSX.Element = (
            <EditFulfillerModal fulfiller={f} onSubmit={() => fetch()} />
        )
        openModal({
            heading: t('fulfillment.edit_modal.heading'),
            content: content,
        })
    }

    return (
        <div>
            <Button
                hierarchy={'secondary'}
                text={t('fulfillment.add')}
                classes={'zr-mt-4'}
                fn={() => openCreateModal()}
            />
            {isLoading && (
                <div className={'zr-w-100 zr-d-flex zr-justify-center'}>
                    <Loader size={'m'} isLoading={isLoading} />
                </div>
            )}
            {fulfiller.length > 0 && (
                <table className={cx(styles['zr-table'])}>
                    <thead className={cx(styles['table-header'])}>
                        <tr>
                            <th>
                                <strong>{t('fulfillment.list.id')}</strong>
                            </th>
                            <th>
                                <strong>{t('fulfillment.list.email')}</strong>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {fulfiller.map((fulfiller: Fulfiller) => {
                            return (
                                <React.Fragment key={fulfiller.id}>
                                    <tr
                                        className={'zr-cursor-pointer'}
                                        key={fulfiller.id}
                                        onClick={() => openEditModal(fulfiller)}
                                    >
                                        <td>{fulfiller.id}</td>
                                        <td>{fulfiller.email}</td>
                                    </tr>
                                </React.Fragment>
                            )
                        })}
                    </tbody>
                </table>
            )}
        </div>
    )
}

export default FulfillmentList
